enum StatsTabType {
  Collectors = "Collectors",
  Creators = "Creators",
}

export default StatsTabType;
